{
  "v8e.accueil.categorie.confirmer": "Je confirme la suppression de cette catégorie.",
  "v8e.accueil.categorie.quoi": "La catégorie",
  "v8e.accueil.categorie.supprimable": "« {{label}} » n’a aucune entrée : elle peut être supprimée.",
  "v8e.accueil.categorie.supprimee": "Catégorie supprimée ; le geste est écrit au journal.",
  "v8e.accueil.categorie.supprimer": "Supprimer la catégorie",
  "v8e.accueil.categorie.utilisee": "« {{label}} » est utilisée par {{n}} entrée(s) : elle reste.",
  "v8e.accueil.code.ACCESS_REQUEST_NOT_PENDING": "Cette demande a déjà été décidée par une autre personne.",
  "v8e.accueil.code.ACCESS_REQUEST_SELF_DECISION": "Vous ne décidez pas votre propre demande d’accès.",
  "v8e.accueil.code.ORGANISATION_DESCRIPTION_TOO_LONG": "La description compte 2000 caractères au plus.",
  "v8e.accueil.code.ORGANISATION_ID_IMMUTABLE": "L’identifiant d’une organisation ne se modifie pas.",
  "v8e.accueil.code.ORGANISATION_NAME_INVALID": "Le nom de l’organisation doit compter de 2 à 120 caractères.",
  "v8e.accueil.code.ORGANISATION_NOT_FOUND": "Organisation introuvable.",
  "v8e.accueil.code.ORGANISATION_PROFILE_UNCHANGED": "Rien à enregistrer : nom et description inchangés.",
  "v8e.accueil.code.PROFIL_NIVEAU_INCOMPATIBLE": "Ce profil ne se pose pas sur un projet.",
  "v8e.accueil.code.TECH_CATEGORY_IN_USE": "Cette catégorie est utilisée par des entrées du catalogue : elle reste.",
  "v8e.accueil.code.TECH_CATEGORY_PLATFORM_FLOOR": "Cette catégorie est un plancher de la plateforme : elle n’est jamais supprimée.",
  "v8e.accueil.code.WORKSPACE_ARCHIVED": "Ce projet est archivé : il n’accueille plus de membres.",
  "v8e.accueil.compteur.approbations": "Approbations en attente",
  "v8e.accueil.compteur.archives": "archivés",
  "v8e.accueil.compteur.documents": "Documents ingérés",
  "v8e.accueil.compteur.membres": "Membres",
  "v8e.accueil.compteur.palier": "Palier",
  "v8e.accueil.compteur.programmes": "Programmes",
  "v8e.accueil.compteur.projets": "Projets",
  "v8e.accueil.compteur.travaux": "Travaux en cours ou en attente",
  "v8e.accueil.decider.titre": "Ce qui attend une décision",
  "v8e.accueil.decision.approved": "{{objet}} approuvé par {{qui}} ({{quand}})",
  "v8e.accueil.decision.rejected": "{{objet}} refusé par {{qui}} ({{quand}})",
  "v8e.accueil.demandes.accepter": "Accepter",
  "v8e.accueil.demandes.dejaDecidee": "Déjà décidée par une autre personne.",
  "v8e.accueil.demandes.ligne": "{{qui}} demande l’accès au projet « {{projet}} »",
  "v8e.accueil.demandes.motif": "Motif du refus (facultatif)",
  "v8e.accueil.demandes.notifiee": "Décision enregistrée ; la personne est notifiée.",
  "v8e.accueil.demandes.profil": "Profil accordé sur le projet",
  "v8e.accueil.demandes.refuser": "Refuser",
  "v8e.accueil.demandes.titre": "Demandes d’accès aux projets",
  "v8e.accueil.demandes.vide": "Aucune demande d’accès à décider.",
  "v8e.accueil.etape.activer_les_modeles_d_ia": "Activer les modèles d’IA",
  "v8e.accueil.etape.ajouter_un_moyen_de_paiement": "Ajouter un moyen de paiement",
  "v8e.accueil.etape.choisir_le_palier": "Choisir le palier",
  "v8e.accueil.etape.creer_le_premier_projet": "Créer le premier projet",
  "v8e.accueil.etape.inviter_l_equipe": "Inviter l’équipe",
  "v8e.accueil.etape.inviter_un_administrateur": "Inviter un administrateur",
  "v8e.accueil.etape.proposer_les_modeles_d_espace": "Proposer les modèles d’espace",
  "v8e.accueil.etape.regler_la_securite_de_connexion": "Régler la sécurité de connexion",
  "v8e.accueil.etape.renseigner_la_facturation": "Renseigner les coordonnées de facturation",
  "v8e.accueil.etapeEtat.a_faire": "À faire",
  "v8e.accueil.etapeEtat.en_attente": "En attente d’acceptation",
  "v8e.accueil.etapeEtat.fait": "Fait",
  "v8e.accueil.etapeEtat.non_disponible": "Non disponible (vague {{port}})",
  "v8e.accueil.fiche.activationEnAttente": "activation en attente",
  "v8e.accueil.fiche.administrateurs": "Qui administre l’organisation",
  "v8e.accueil.fiche.aucunAdministrateur": "Aucun administrateur nommé : le propriétaire administre.",
  "v8e.accueil.fiche.compteurs": "En chiffres",
  "v8e.accueil.fiche.derogations": "Dérogations",
  "v8e.accueil.fiche.description": "Description",
  "v8e.accueil.fiche.descriptionTropLongue": "{{max}} caractères au plus.",
  "v8e.accueil.fiche.detailsTechniques": "Détails techniques",
  "v8e.accueil.fiche.enregistree": "Identité enregistrée.",
  "v8e.accueil.fiche.enregistrer": "Enregistrer l’identité",
  "v8e.accueil.fiche.gouvernance": "Réglages de gouvernance",
  "v8e.accueil.fiche.identifiantFige": "L’identifiant {{id}} reste figé : il est porté par les jetons, les liens et l’audit.",
  "v8e.accueil.fiche.identite": "Identité de l’organisation",
  "v8e.accueil.fiche.integrations": "Intégrations",
  "v8e.accueil.fiche.nom": "Nom de l’organisation",
  "v8e.accueil.fiche.nomInvalide": "De {{min}} à {{max}} caractères.",
  "v8e.accueil.fiche.onglet.apercu": "Aperçu",
  "v8e.accueil.fiche.onglet.cles-d-api": "Clés d’API",
  "v8e.accueil.fiche.onglet.integrations-ia": "Intégrations IA",
  "v8e.accueil.fiche.onglet.propriete-et-cycle-de-vie": "Propriété et cycle de vie",
  "v8e.accueil.fiche.onglet.webhooks": "Webhooks",
  "v8e.accueil.fiche.ongletAutreVague": "Cet onglet est livré par un autre paquet de la vague.",
  "v8e.accueil.fiche.onglets": "Sections de la fiche de l’organisation",
  "v8e.accueil.fiche.resumeDerogations": "{{aDecider}} à décider, {{accordees}} accordées, {{echues}} échues",
  "v8e.accueil.fiche.rien": "Rien à enregistrer.",
  "v8e.accueil.fiche.statut": "Statut : {{statut}}",
  "v8e.accueil.ia.arretee": "IA arrêtée depuis le {{depuis}} par {{par}} : {{motif}}",
  "v8e.accueil.ia.arreteePlateforme": "IA arrêtée par la plateforme.",
  "v8e.accueil.ia.arreter": "Arrêter l’IA de l’organisation",
  "v8e.accueil.ia.enService": "IA en service.",
  "v8e.accueil.ia.relancer": "Relancer l’IA de l’organisation",
  "v8e.accueil.ia.titre": "État de l’IA de l’organisation",
  "v8e.accueil.invitations.lienATransmettre": "Nouveau lien créé : transmettez-le vous-même.",
  "v8e.accueil.invitations.nouveauLien": "Nouveau lien",
  "v8e.accueil.lesVotres": "demandée par vous : une autre personne décide",
  "v8e.accueil.lien.lien-abonnement-et-facturation": "Abonnement et facturation",
  "v8e.accueil.lien.lien-confirmer-l-autorisation": "Confirmer l’autorisation",
  "v8e.accueil.lien.lien-creer-un-projet": "Créer un projet",
  "v8e.accueil.lien.lien-decider-la-derogation": "Décider la dérogation",
  "v8e.accueil.lien.lien-decider-la-finalite": "Décider la finalité",
  "v8e.accueil.lien.lien-decider-le-changement": "Décider le changement",
  "v8e.accueil.lien.lien-documents-ingeres": "Documents ingérés",
  "v8e.accueil.lien.lien-inviter-une-personne": "Inviter une personne",
  "v8e.accueil.lien.lien-ouvrir-l-exigence": "Ouvrir l’exigence",
  "v8e.accueil.lien.lien-ouvrir-le-catalogue": "Ouvrir le catalogue",
  "v8e.accueil.lien.lien-ouvrir-le-harnais": "Ouvrir le harnais",
  "v8e.accueil.lien.lien-ouvrir-le-journal": "Ouvrir le journal",
  "v8e.accueil.lien.lien-ouvrir-les-connexions-et-modeles": "Connexions et modèles",
  "v8e.accueil.lien.lien-ouvrir-les-validations": "Ouvrir les validations",
  "v8e.accueil.lien.lien-publier-l-exigence": "Publier l’exigence",
  "v8e.accueil.lien.lien-regler-la-gouvernance": "Régler la gouvernance",
  "v8e.accueil.lien.lien-reprendre-les-premiers-pas": "Reprendre les premiers pas",
  "v8e.accueil.lien.lien-retour-a-l-accueil": "Retour à l’accueil",
  "v8e.accueil.lien.lien-valider-la-version-de-charte": "Valider la version de charte",
  "v8e.accueil.lien.lien-voir-l-abonnement": "Voir l’abonnement",
  "v8e.accueil.lien.lien-voir-la-sante": "Voir la santé",
  "v8e.accueil.lien.lien-voir-les-axes": "Voir les axes",
  "v8e.accueil.lien.lien-voir-les-membres": "Voir les membres",
  "v8e.accueil.lien.lien-voir-les-nouvelles-piles": "Voir les nouvelles piles",
  "v8e.accueil.lien.lien-voir-les-projets": "Voir les projets",
  "v8e.accueil.lien.lien-voir-les-suppressions-programmees": "Voir les suppressions programmées",
  "v8e.accueil.ordre.asc": "croissant",
  "v8e.accueil.ordre.desc": "décroissant",
  "v8e.accueil.premiersPas.afficher": "Afficher les premiers pas",
  "v8e.accueil.premiersPas.enregistre": "Choix enregistré pour vous seul.",
  "v8e.accueil.premiersPas.masquer": "Masquer les premiers pas",
  "v8e.accueil.premiersPas.masques": "Premiers pas masqués par vous.",
  "v8e.accueil.premiersPas.progression": "{{k}} étape(s) faite(s) sur {{n}}",
  "v8e.accueil.premiersPas.titre": "Premiers pas",
  "v8e.accueil.profil.administrateur-projet": "Administrateur de projet",
  "v8e.accueil.profil.architecte": "Architecte",
  "v8e.accueil.profil.developpeur": "Développeur",
  "v8e.accueil.profil.lecteur": "Lecteur (par défaut)",
  "v8e.accueil.profil.metier-commanditaire": "Métier / commanditaire",
  "v8e.accueil.profil.responsable-mises-en-production": "Responsable des mises en production",
  "v8e.accueil.profil.responsable-produit": "Responsable produit",
  "v8e.accueil.profil.scrum-master": "Scrum Master",
  "v8e.accueil.profil.testeur": "Testeur",
  "v8e.accueil.raccourcis": "Raccourcis de l’administration",
  "v8e.accueil.section.autorisations_sensibles": "Autorisations sensibles à confirmer",
  "v8e.accueil.section.changements": "Changements technologiques à décider",
  "v8e.accueil.section.derogations": "Dérogations à décider",
  "v8e.accueil.section.exigences_a_publier": "Exigences à publier",
  "v8e.accueil.section.exigences_a_valider": "Exigences à valider",
  "v8e.accueil.section.finalites": "Finalités d’IA à décider",
  "v8e.accueil.section.invitations_expirees": "Invitations expirées",
  "v8e.accueil.section.nombre": "{{n}} élément(s)",
  "v8e.accueil.section.nonDisponible": "Pas encore disponible : livré avec la vague {{port}}.",
  "v8e.accueil.section.nouvelles_piles": "Nouvelles piles qualifiées",
  "v8e.accueil.section.objets_a_valider": "Objets à valider",
  "v8e.accueil.section.versions_de_charte": "Versions de charte à valider",
  "v8e.accueil.statut.active": "active",
  "v8e.accueil.statut.deleting": "suppression programmée",
  "v8e.accueil.statut.suspended": "suspendue (lecture seule)",
  "v8e.accueil.surveiller.connexion": "Connexion IA injoignable : {{nom}}",
  "v8e.accueil.surveiller.delegation": "Délégation sur « {{projet}} » qui expire le {{date}}",
  "v8e.accueil.surveiller.droitIsole": "Droit {{droit}} de {{personne}} qui expire le {{date}}",
  "v8e.accueil.surveiller.mfa": "{{n}} compte(s) sans second facteur alors qu’il est exigé",
  "v8e.accueil.surveiller.mfaNonMesure": "Second facteur exigé : l’état des comptes se lit dans la sécurité de l’organisation.",
  "v8e.accueil.surveiller.quota": "Quota {{ressource}} de « {{projet}} » à {{pourcentage}} %",
  "v8e.accueil.surveiller.rien": "Rien à surveiller.",
  "v8e.accueil.surveiller.suppression": "Suppression de « {{projet}} » programmée le {{date}}",
  "v8e.accueil.surveiller.titre": "À surveiller",
  "v8e.accueil.tri.approbations_en_attente": "Approbations en attente",
  "v8e.accueil.tri.derniere_activite": "Dernière activité",
  "v8e.accueil.tri.nom": "Espace",
  "v8e.accueil.tri.travaux_en_cours": "Travaux en cours",
  "v8e.accueil.vue.agents": "Agents disponibles",
  "v8e.accueil.vue.archive": "archivé : lecture seule",
  "v8e.accueil.vue.archiver": "Archiver",
  "v8e.accueil.vue.artefact": "{{titre}} — {{projet}}",
  "v8e.accueil.vue.artefacts": "Derniers artefacts",
  "v8e.accueil.vue.aucunEspace": "Aucun espace.",
  "v8e.accueil.vue.commencer": "Commencez par créer un premier espace ; déposer une idée se fait ensuite dans le projet.",
  "v8e.accueil.vue.compteurs": "Compteurs",
  "v8e.accueil.vue.creer": "Créer un projet",
  "v8e.accueil.vue.creerPremier": "Créer mon premier espace",
  "v8e.accueil.vue.decisions": "Décisions récentes",
  "v8e.accueil.vue.espaces": "Espaces",
  "v8e.accueil.vue.modeles": "Modèles servis",
  "v8e.accueil.vue.nombreAgents": "{{n}} agent(s) publié(s)",
  "v8e.accueil.vue.nonAccessibles": "{{n}} projet(s) non accessible(s) : comptés, jamais nommés.",
  "v8e.accueil.vue.ordre": "Ordre",
  "v8e.accueil.vue.reserveAuxDetenteurs": "La vue d’ensemble de l’organisation est réservée aux détenteurs du droit « voir les membres de l’organisation » : l’administration de l’organisation et l’auditeur. Vos projets restent dans le sélecteur de contexte.",
  "v8e.accueil.vue.sansDescription": "Sans description",
  "v8e.accueil.vue.sante": "Santé de la conformité",
  "v8e.accueil.vue.santeComptes": "{{bonne}} bonne(s), {{a_surveiller}} à surveiller, {{degradee}} dégradée(s), {{sans_donnee}} sans donnée",
  "v8e.accueil.vue.trierPar": "Trier par"
}
